module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "free-term",
    class: {
      'highlighted': _vm.showChoosingPrompt || _vm.showChangingPrompt
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("dateFilter")(_vm.freeTerm.date)))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.freeTerm.timeFrom) + " - " + _vm._s(_vm.freeTerm.timeTo))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "doctor"
  }, [_vm._v(_vm._s(_vm.freeTerm.doctor_name))]), _vm._v(" "), _c('div', {
    staticClass: "specialty"
  }, [_vm._v(_vm._s(_vm.specialtyName))])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "department-name"
  }, [_vm._v(_vm._s(_vm.department.name))]), _vm._v(" "), _c('div', {
    staticClass: "department-address"
  }, [_vm._v("\n                " + _vm._s(_vm.department.city) + ", ul. " + _vm._s(_vm.department.street) + " " + _vm._s(_vm.department.house_number) + "\n                "), (_vm.department.flat_number) ? [_vm._v(" lok. " + _vm._s(_vm.department.flat_number))] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "department-telephone"
  }, [_vm._v("Tel: " + _vm._s(_vm.department.telephone))])])]), _vm._v(" "), (_vm.isNew) ? _c('div', {
    staticClass: "buttons"
  }, [(!_vm.showChoosingPrompt) ? _c('button', {
    staticClass: "btn-outline-blue btn-choose",
    class: {
      'btn-outline-grey': _vm.isDisabled, 'not-allowed': _vm.isDisabled
    },
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.toggleShowChoosingPrompt
    }
  }, [_vm._v("WYBIERZ")]) : [_c('div', {
    staticClass: "prompt"
  }, [_vm._v("Czy na pewno chcesz wybrać wizytę?")]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-buttons"
  }, [_c('button', {
    staticClass: "btn-outline-blue",
    on: {
      "click": _vm.chooseFreeTerm
    }
  }, [_vm._v("Tak")]), _vm._v(" "), _c('button', {
    staticClass: "btn-outline-orange",
    on: {
      "click": _vm.toggleShowChoosingPrompt
    }
  }, [_vm._v("Nie")])])]], 2) : _vm._e(), _vm._v(" "), (_vm.isChosen) ? _c('div', {
    staticClass: "buttons"
  }, [(!_vm.showChangingPrompt) ? _c('button', {
    staticClass: "btn-outline-blue btn-choose",
    on: {
      "click": _vm.toggleShowChangingPrompt
    }
  }, [_vm._v("ZMIEŃ")]) : [_c('div', {
    staticClass: "prompt"
  }, [_vm._v("Czy na pewno chcesz zmienić wizytę?")]), _vm._v(" "), _c('div', {
    staticClass: "confirmation-buttons"
  }, [_c('button', {
    staticClass: "btn-outline-blue",
    on: {
      "click": _vm.changeFreeTerm
    }
  }, [_vm._v("Tak")]), _vm._v(" "), _c('button', {
    staticClass: "btn-outline-orange",
    on: {
      "click": _vm.toggleShowChangingPrompt
    }
  }, [_vm._v("Nie")])])]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoosingPrompt || _vm.isChosen),
      expression: "showChoosingPrompt || isChosen"
    }],
    staticClass: "row"
  }, [_c('label', {
    staticClass: "note-label"
  }, [_vm._v("Dodaj notatkę:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freeTerm.patient_note),
      expression: "freeTerm.patient_note"
    }],
    staticClass: "patient-note",
    domProps: {
      "value": (_vm.freeTerm.patient_note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.freeTerm, "patient_note", $event.target.value)
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/calendar-blue.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/doctor-blue.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-container"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/place-blue.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4be9670a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FreeTerm.vue
// module id = 205
// module chunks = 0